import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import About from "@/pages/home/components/About";
import ChefPicks from "@/pages/home/components/ChefPicks";
import Sando from "@/pages/home/components/Sando";
import LocationSection from "@/pages/home/components/LocationSection";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFab from "@/pages/home/components/WhatsAppFab";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-cream font-sans text-darktext">
      <Header />

      <main>
        <Hero />
        <About />
        <ChefPicks />
        <Sando />
        <LocationSection />
        <Contact />
      </main>

      <Footer />
      <WhatsAppFab />
    </div>
  );
}